// Single source of truth for the Google Maps JS API libraries.
//
// @react-google-maps/api loads ONE global Maps script for the whole app. Every
// useJsApiLoader / useLoadScript / LoadScript call must therefore request the
// SAME libraries array (and the SAME reference, to avoid "LoadScript reloaded"
// warnings). If different components request different libraries, whichever map
// mounts first wins — and any component that needs a library missing from that
// first set (e.g. Places Autocomplete needs "places") throws an invariant.
//
// Keep this list a superset of everything the app uses: "marker" (advanced
// markers on the dashboards) + "places" (location search on add-centre).
export const MAP_LIBRARIES = ["marker", "places"];
